import { Box, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { MissingAmendsDialogLine } from "./missing-amends-dialog-line"
import { DialogBox } from "lib/@components/dialogBox"
import { Done } from "lib/@components/done"

export function MissingAmendsDialog({ lines, items, projectId, scheduleId }) {
    const resolvedItems = items ?? (lines ?? []).map((label) => ({ label, amendsKey: null }))

    return (
        <DialogBox
            Actions={Done}
            okCaption="Ok"
            title={
                <Box display={"flex"} alignItems={"center"} gap={"20px"}>
                    <Typography variant="h5">Author Notes Required</Typography>
                </Box>
            }
            data-cy="missing-amends-dialog"
        >
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Author notes are required for all changed content before submission.
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                Please add notes for:
            </Typography>
            <Box sx={{ p: 2, borderRadius: 1, bgcolor: "action.hover" }}>
                <Repeat
                    list={resolvedItems}
                    item={<MissingAmendsDialogLine projectId={projectId} scheduleId={scheduleId} />}
                    pass="item"
                />
            </Box>
        </DialogBox>
    )
}
